var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyCircled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.7578,
    r: 16,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 24.7578H9V11.7578C9 11.2078 8.55 10.7578 8 10.7578C7.45 10.7578 7 11.2078 7 11.7578V24.7578C7 25.8578 7.9 26.7578 9 26.7578H19C19.55 26.7578 20 26.3078 20 25.7578C20 25.2078 19.55 24.7578 19 24.7578ZM24 20.7578V8.75781C24 7.65781 23.1 6.75781 22 6.75781H13C11.9 6.75781 11 7.65781 11 8.75781V20.7578C11 21.8578 11.9 22.7578 13 22.7578H22C23.1 22.7578 24 21.8578 24 20.7578ZM22 20.7578H13V8.75781H22V20.7578Z",
    fill: "#646471"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCircled);
export default __webpack_public_path__ + "static/media/copy-circled.b9fcdfbd.svg";
export { ForwardRef as ReactComponent };